/// <reference path="clientApp.module.ts" />
/// <reference path="../../components/common/businessinfo.service.ts" />
/// <reference path="../../components/commonClasses/commonControllerBase.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.ClientApp {
    export class ClientAppController extends Meevo.Components.CommonClasses.CommonControllerBase {
        // statically inject constructor resources
        static $inject = [
            "meevo.AppSettings",
            "meevo.components.common.BusinessInfoDataService",
            "meevo.components.modal.ModalService",
            "meevo.components.common.IdentityService",
            "meevo.components.logging.LoggingService",
            "meevo.components.common.SecurityService",
            "meevo.components.tracking.TrackingService",
            "$rootScope",
            "$scope",
            "$state",
            "meevo.ContextParams",
            'meevo.components.short-cuts.ShortCutsService',
            "meevo.components.busy.BusyService",
            "$mdToast",
            "$translate",
            "meevo.components.common.DataService",
            '$filter',
            "$q"
        ];

        public issingleLocation: boolean = false;

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.Common.BusinessInfoDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            public $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $mdToast: angular.material.IToastService,
            protected $translate: angular.translate.ITranslateService,
            protected baseDataService: Meevo.Components.BaseClasses.IDataService,
            protected $filter: angular.IFilterService,
            protected $q: ng.IQService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

            this.createContext();

            if (this.identityService.current().isSingleLocation) {
                this.issingleLocation = true;
            }
        }

        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.INTEGRATION_CLIENTAPP).then(() => {
                this.busyService.stop();
                this.context = new ClientAppContext(this, this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.busyService, this.$rootScope, this.$scope, this.$mdToast, this.$translate, this.baseDataService, this.$filter, this.$q);
                super.createContext();
            });
        }

    }

    angular.module("meevo.plugins.clientApp", ['ui.swiper'])
        .controller("meevo.plugins.clientApp.ClientAppController", ClientAppController);
}